import { QuestionnaireResponse } from '../../types/fhir';
import { firstNonEmpty, formatUtcForFileName, sanitizeFileNameSegment } from '../questionnaireResponseCsv';
import { getPatientIdentity, ResponsePdfTask } from './responsePdfDocument';

// Same naming as the CSV export, plus the questionnaire or material title.
export const buildResponsePdfFileName = ({
    task,
    questionnaireResponse,
    title,
}: {
    task: ResponsePdfTask;
    questionnaireResponse: QuestionnaireResponse;
    title?: string;
}): string => {
    const patient = getPatientIdentity(task, questionnaireResponse);
    const answeredAt =
        firstNonEmpty(questionnaireResponse.authored, questionnaireResponse.meta?.lastUpdated) || 'unknown-datetime';

    return (
        [
            sanitizeFileNameSegment(patient.name || 'unknown-patient', 'unknown-patient'),
            sanitizeFileNameSegment(patient.id || 'unknown-user', 'unknown-user'),
            sanitizeFileNameSegment(title || 'response', 'response'),
            sanitizeFileNameSegment(formatUtcForFileName(answeredAt), 'unknown-datetime'),
        ].join('_') + '.pdf'
    );
};

export const buildCombinedPdfFileName = (responseCount: number, exportedAt: Date): string =>
    `koala-antworten_${responseCount}_${formatUtcForFileName(exportedAt.toISOString())}.pdf`;
